<span
  *ngIf="firstCurrencyName && secondCurrencyName"
  class="currency-pair-icon"
  [ngClass]="{ 'currency-pair-icon-dark': isDarkColorScheme$ | async }"
>
  <img class="currency-pair-icon-img" [src]="firstCurrencyIcon" [alt]="firstCurrencyName" />
  <img class="currency-pair-icon-img" [src]="secondCurrencyIcon" [alt]="secondCurrencyName" />
</span>
